export enum MFAType {
  GOOGLE_AUTH = 'GOOGLE_AUTH',
  MAGIC_LINK = 'MAGIC_LINK',
  PASSKEY = 'PASSKEY',
}

export interface MFAStatus {
  isEnabled: boolean;
  isRequired: boolean;
  isEnforced: boolean;
  enabledMethods: MFAType[];
  primaryMethod?: MFAType | null;
  sessionVerified: boolean;
}

export interface MFASetupResponse {
  success: boolean;
  data?: {
    mfaType: MFAType;
    secret?: string;
    qrCode?: string;
    backupCodes?: string[];
  };
  message?: string;
}

export interface MFAVerifySetupRequest {
  mfaType: MFAType;
  code?: string;
  credential?: Record<string, unknown>;
}

export interface MFAVerifyLoginRequest {
  mfaType: MFAType;
  code?: string;
  credential?: Record<string, unknown>;
}

export interface MFASimpleResponse {
  success: boolean;
  message?: string;
  data?: unknown;
}

export interface MFAVerifyLoginResponse {
  success: boolean;
  accessToken?: string;
  refreshToken?: string;
  tokenId?: string;
  expiresAt?: number;
  user?: unknown;
  message?: string;
  error_code?: string;
}

export interface MagicLinkSendResponse {
  success: boolean;
  message?: string;
}

export interface MagicLinkActivateRequest {
  token: string;
}
